/**
 * -----------------------------------------------------------------------------
 * It illustration showing a woman verifying her identity.
 * TODO: remove the inline colors later.
 */
export function IdentifyVerificationIllustrationSVG() {
  return (
    <svg fill="none" height="200" viewBox="0 0 185 200" width="185">
      <g opacity={0.5}>
        <path
          d="M182 154.433H3.31v.09H182v-.09Zm-17.905 5.751h-11.836v.089h11.836v-.089Zm-42.414.972h-3.105v.089h3.105v-.089Zm30.22-4.289h-6.858v.09h6.858v-.09Zm-114.408.601H22.058v.089h15.435v-.089Zm5.447 0h-2.262v.089h2.262v-.089Zm40.834 1.508h-33.48v.089h33.48v-.089Zm4.235-20.482H19.002a2.039 2.039 0 0 1-2.037-2.04V39.45a2.04 2.04 0 0 1 2.038-2.023h69.006a2.04 2.04 0 0 1 2.04 2.04v96.987a2.042 2.042 0 0 1-2.04 2.04ZM19.002 37.499a1.95 1.95 0 0 0-1.947 1.951v97.004a1.95 1.95 0 0 0 1.948 1.951h69.006a1.955 1.955 0 0 0 1.951-1.951V39.45a1.955 1.955 0 0 0-1.951-1.951H19.002Zm146.312 100.995h-69.01a2.046 2.046 0 0 1-2.04-2.04V39.45a2.044 2.044 0 0 1 2.04-2.023h69.01a2.04 2.04 0 0 1 2.034 2.023v97.004a2.04 2.04 0 0 1-2.034 2.04ZM96.304 37.499a1.955 1.955 0 0 0-1.951 1.951v97.004a1.952 1.952 0 0 0 1.95 1.951h69.011a1.956 1.956 0 0 0 1.951-1.951V39.45a1.958 1.958 0 0 0-1.951-1.951h-69.01Z"
          fill="#D4D4D4"
        />
        <path
          d="M102.633 100.351h58.903v-52.75h-58.903v52.75Z"
          fill="#A3A3A3"
        />
        <path
          d="M100.149 100.351h60.226v-52.75h-60.226v52.75Z"
          fill="#F9FAFB"
        />
        <path
          d="M102.633 102.138h58.903v-1.787h-58.903v1.787Z"
          fill="#A3A3A3"
        />
        <path d="M96.018 102.138h60.226v-1.787H96.018v1.787Z" fill="#F9FAFB" />
        <path
          d="M156.905 96.877V51.076h-53.282v45.801h53.282Z"
          fill="#6B21A8"
        />
        <path
          d="m146.198 96.881-20.382-45.805H104.96l20.381 45.805h20.857Zm9.099-7.655a.246.246 0 0 0 .246-.247V53.338a.247.247 0 0 0-.421-.175.247.247 0 0 0-.072.175v35.641a.247.247 0 0 0 .247.247ZM117.5 96.881 97.119 51.076h-7.216l20.381 45.805h7.216Z"
          fill="#F9FAFB"
        />
        <path d="M104.063 96.877V51.076h-.44v45.801h.44Z" fill="#A3A3A3" />
        <path
          d="M99.327 55.847h58.907l.318-3.42H99.649l-.322 3.42Zm0 5.646h58.907l.318-3.42H99.649l-.322 3.42Zm0 5.647h58.907l.318-3.42H99.649l-.322 3.42Zm0 5.647h58.907l.318-3.42H99.649l-.322 3.42Zm0 5.65h58.907l.318-3.42H99.649l-.322 3.42Zm0 5.646h58.907l.318-3.42H99.649l-.322 3.42Z"
          fill="#A3A3A3"
          opacity={0.5}
        />
        <path
          d="M31.136 154.433h46.938V47.606H31.136v106.827Z"
          fill="#F9FAFB"
        />
        <path
          d="M31.136 154.433h46.012V47.606H31.136v106.827Z"
          fill="#A3A3A3"
        />
        <path d="M74.725 154.433V50.029H33.56v104.404h41.166Z" fill="#D4D4D4" />
        <path
          d="M44.734 97.825c-2.334-.644-4.668 1.43-7.001.786a1.466 1.466 0 0 1-.897-1.294c0-.493.404-.636.897-.504 2.333.643 4.667-1.43 7-.786a1.457 1.457 0 0 1 .901 1.29c0 .508-.407.647-.9.508Z"
          fill="#F9FAFB"
        />
        <path d="M34.191 154.433V50.029h-.629v104.404h.63Z" fill="#D4D4D4" />
        <path
          d="M151.798 152.078h8.42v-36.51h-8.42v36.51Zm-34.713 2.313h41.517v-2.313h-41.517v2.313Z"
          fill="#F9FAFB"
        />
        <path d="M151.801 115.565H115.47v36.51h36.331v-36.51Z" fill="#A3A3A3" />
        <path
          d="M148.489 120.061H118.78v11.972h29.709v-11.972Zm0 15.546H118.78v11.972h29.709v-11.972Z"
          fill="#F9FAFB"
        />
        <path
          d="M130.301 121.068h6.669a.82.82 0 1 0 0-1.64h-6.669a.82.82 0 1 0 0 1.64Zm-.003 15.55h6.672a.825.825 0 0 0 .822-.822.827.827 0 0 0-.822-.804h-6.672a.82.82 0 0 0-.819.822.822.822 0 0 0 .819.804Z"
          fill="#A3A3A3"
        />
        <path
          d="M143.971 114.847a.628.628 0 0 1-.625-.622v-18.97a.63.63 0 0 1 .625-.626.629.629 0 0 1 .622.626v18.97a.626.626 0 0 1-.622.622Z"
          fill="#D4D4D4"
        />
        <path d="M149.811 114.11h-11.683v1.473h11.683v-1.473Z" fill="#F9FAFB" />
        <path
          d="M147.205 105.991a.31.31 0 0 1-.31-.311v-9.485a.315.315 0 0 1 .31-.315.315.315 0 0 1 .311.314v9.493a.31.31 0 0 1-.311.304Z"
          fill="#D4D4D4"
        />
        <path
          d="M134.887 99.476s.232-6.977 9.084-6.977c8.853 0 9.081 6.977 9.081 6.977h-18.165Z"
          fill="#A3A3A3"
        />
      </g>
      <path
        d="M92.655 170.573c38.269 0 69.292-1.812 69.292-4.046s-31.023-4.045-69.292-4.045c-38.27 0-69.292 1.811-69.292 4.045s31.023 4.046 69.292 4.046Z"
        fill="#E5E5E5"
      />
      <path
        d="M86.815 69.256c.018-.758.715-1.748 3.524-1.927 2.81-.178 3.853-.05 5.004 2.145 1.25 2.362 2.68 5.003 1.747 7.422-.933 2.42-3.874 3.846-5.979 5.125-2.105 1.28-5.24 5.579-5.24 5.579s-5.842-16.222.944-18.344Z"
        fill="#3B0764"
      />
      <path
        d="M88.099 101.623s4.256 21.851 5.768 30.735c1.569 9.238 2.89 29.116 2.89 29.116h2.367s3.012-17.154 0-29.895c.203-10.171-1.787-31.324-1.787-31.324l-9.239 1.368Z"
        fill="#FEE2E2"
      />
      <path
        d="M91.2 101.162s9.335 22.851 12.587 31.253c4.561 6.112 16.022 19.074 16.651 19.335l.829-1.87s-7.005-13.698-12.651-20.467c-1.501-10.06-8.653-29.548-8.653-29.548l-8.762 1.297ZM86.805 87.41c-.672.787-1.362 1.537-2.052 2.302-.69.765-1.4 1.501-2.112 2.244a78.662 78.662 0 0 1-2.173 2.202c-.743.718-1.49 1.43-2.273 2.144l.118-.125a2.616 2.616 0 0 1-1.136.765 4.003 4.003 0 0 1-.965.218 8.33 8.33 0 0 1-1.633 0 19.591 19.591 0 0 1-2.902-.5 40.84 40.84 0 0 1-2.738-.787 30.29 30.29 0 0 1-2.655-.983.75.75 0 0 1 .443-1.425c.883.185 1.787.375 2.68.535.894.161 1.787.319 2.677.43.86.122 1.727.19 2.595.203a5.84 5.84 0 0 0 1.14-.09c.13-.023.257-.06.379-.11a.157.157 0 0 0 .06-.04s-.024 0-.057.043l.118-.125a91.064 91.064 0 0 0 2.08-2.162l2.052-2.233 4.074-4.507a1.51 1.51 0 0 1 2.27 1.99l.01.011Z"
        fill="#FEE2E2"
      />
      <path
        d="m67.328 93.668-1.476-2.584-1.037 2.81s1.255 1.429 2.448 1.146l.065-1.372Z"
        fill="#FEE2E2"
      />
      <path
        d="m63.979 91.16-.358 1.204a.716.716 0 0 0 .23.757l.968.787 1.022-2.824-.908-.357a.715.715 0 0 0-.954.432Z"
        fill="#FEE2E2"
      />
      <path
        d="M86.833 83.805c-2.101-.358-3.03 1.107-4.034 2.212.239 1.951 3.68 5.954 3.68 5.954s4.175-7.545.354-8.166Z"
        fill="#9333EA"
      />
      <path
        d="M84.039 86.199c.268 2.126 1.283 8.095 4.127 17.029l12.405-1.83c-.858-4.495-2.04-8.745-1.494-17.697a1.81 1.81 0 0 0-1.812-1.92c-.84 0-1.876.036-2.955.144a38.608 38.608 0 0 0-5.39.797c-1.143.278-2.355.65-3.277.95A2.358 2.358 0 0 0 84.04 86.2Z"
        fill="#9333EA"
      />
      <path
        d="m88.92 82.715 5.39-.797s-.247 2.069-3.642 4.788c-2.58-2.394-1.748-3.992-1.748-3.992Z"
        fill="#fff"
      />
      <path
        d="M92.88 75.928c-.085 1.787.047 5.003 1.43 5.99a10.532 10.532 0 0 1-3.478 3.459 3.12 3.12 0 0 1-1.911-2.662c1.865-.747 1.604-2.173 1.072-3.47l2.887-3.317Z"
        fill="#FEE2E2"
      />
      <path
        d="m91.7 77.282-1.711 1.959c.13.3.233.613.307.933.715-.215 1.62-1.176 1.584-1.963a2.6 2.6 0 0 0-.18-.929Z"
        fill="#3B0764"
        opacity={0.2}
      />
      <path
        d="M94.238 72.48c-.264 2.919-.314 4.159-1.833 5.617-2.287 2.198-5.815 1.237-6.433-1.705-.554-2.644-.032-6.976 2.86-8.058a3.999 3.999 0 0 1 5.406 4.145Z"
        fill="#FEE2E2"
      />
      <path
        d="M91.998 70.206c-.258 1.748.775 3.888 1.668 3.91.894.021 1.566-3.352 1.566-3.352l-3.234-.558Z"
        fill="#3B0764"
      />
      <path
        d="M87.033 69.313c1.905 1.35 7.566 3.377 7.684 1.63.118-1.748-2.244-3.16-3.992-3.16-1.747 0-3.155.697-3.692 1.53Z"
        fill="#3B0764"
      />
      <path
        d="m93.406 129.721 5.718-2.248a174.078 174.078 0 0 0-.143-4.289l-6.326 2.295c.261 1.515.522 2.952.75 4.242Zm13.187-9.328-6.612 2.409a852.344 852.344 0 0 1 1.498 3.738l6.075-2.398c-.293-1.212-.604-2.47-.961-3.749Z"
        fill="#3B0764"
        opacity={0.2}
      />
      <path
        d="M89.957 73.248c0 .239-.136.428-.293.421-.157-.007-.275-.2-.268-.436.007-.236.136-.429.293-.425.157.003.275.2.268.44Zm-2.692-.077c.007-.239-.114-.436-.27-.44-.156-.005-.288.185-.295.424-.007.239.114.436.27.44.156.005.288-.185.295-.424Z"
        fill="#3B0764"
      />
      <path d="m87.066 72.747-.569-.182s.283.457.569.182Z" fill="#3B0764" />
      <path
        d="M87.966 73.601a6.318 6.318 0 0 1-.893 1.494 1.028 1.028 0 0 0 .847.186l.046-1.68Z"
        fill="#9333EA"
      />
      <path
        d="M88.763 76.167c-.132.02-.266.028-.4.025a.075.075 0 0 1-.068-.071.068.068 0 0 1 .072-.068 1.886 1.886 0 0 0 1.558-.693.068.068 0 0 1 .044-.03.069.069 0 0 1 .071.031.07.07 0 0 1 .01.052.069.069 0 0 1-.01.025 1.96 1.96 0 0 1-1.277.73Z"
        fill="#3B0764"
      />
      <path
        d="M94.867 74.027a2.118 2.118 0 0 1-.979 1.311c-.647.379-1.161-.153-1.14-.865.018-.64.379-1.608 1.108-1.697a.957.957 0 0 1 1.011 1.25Z"
        fill="#FEE2E2"
      />
      <path
        d="M90.958 72.018a.125.125 0 0 1-.104-.036 1.112 1.112 0 0 0-.965-.307.143.143 0 0 1-.064-.275 1.405 1.405 0 0 1 1.218.379.137.137 0 0 1 .042.098.136.136 0 0 1-.042.098.126.126 0 0 1-.085.043Zm-4.378-.225a.128.128 0 0 1-.086-.057.136.136 0 0 1 .036-.193 1.386 1.386 0 0 1 1.261-.193.14.14 0 0 1 .075.182.14.14 0 0 1-.182.079 1.099 1.099 0 0 0-.997.16.143.143 0 0 1-.107.022Zm3.177 1.015-.568-.179s.282.468.568.179Zm-1.591 30.42 4.15 24.538 15.535-4.607c-1.258-12.969-4.475-19.391-7.28-21.761l-12.405 1.83Z"
        fill="#3B0764"
      />
      <path
        d="m94.46 117.016 3.106-5.104-.533-3.591-2.573 8.695Z"
        fill="#3B0764"
        opacity={0.2}
      />
      <path
        d="M98.92 83.007c.264.236.59.508.89.758.3.25.625.508.947.75.64.483 1.283.958 1.951 1.387a15.616 15.616 0 0 0 4.128 1.984c.086.028.175.043.261.064l.128.032h-.05c-.143 0-.196.065-.157.05.205-.138.381-.316.518-.522.436-.625.812-1.29 1.123-1.987.357-.714.671-1.483.968-2.255.297-.772.6-1.554.879-2.326a.753.753 0 0 1 .888-.482.749.749 0 0 1 .563.84 30.291 30.291 0 0 1-1.172 5.088 12.965 12.965 0 0 1-1.129 2.548c-.298.522-.7.976-1.18 1.337-.393.278-.862.43-1.343.436a1.376 1.376 0 0 1-.211 0l-.168-.021-.183-.033c-.117-.021-.243-.035-.357-.064a13.291 13.291 0 0 1-2.68-.872 19.115 19.115 0 0 1-2.405-1.265 25.419 25.419 0 0 1-2.213-1.501 25.054 25.054 0 0 1-1.04-.826 16.533 16.533 0 0 1-1.022-.904A1.512 1.512 0 0 1 98.898 83l.022.007Z"
        fill="#FEE2E2"
      />
      <path
        d="M97.13 81.775c2.144-.126 2.959.99 3.841 2.19-.436 1.916-2.759 5.193-2.759 5.193s-4.946-7.155-1.083-7.383Z"
        fill="#9333EA"
      />
      <path
        d="m110.396 81.117.536-3.148 1.94 2.294s-.679 1.787-1.898 1.926l-.578-1.072Z"
        fill="#FEE2E2"
      />
      <path
        d="m112.704 77.114 1.165 1.022a.554.554 0 0 1 .09.737l-1.291 1.826-1.733-2.73 1.072-.865a.553.553 0 0 1 .697.01Z"
        fill="#FEE2E2"
      />
      <path
        d="M92.27 165.945a4.118 4.118 0 0 1 1.193-.601s2.116-1.197 3.217-4.789l2.447-.611a.448.448 0 0 1 .358.065.433.433 0 0 1 .19.31c.02.193.035.415.06.594.027.389.027.779 0 1.168-.021 1.212-.157 3.932-.157 3.932h-.282a21.314 21.314 0 0 0-.15-2.477c-.144-.801-.715.146-1.023 1.051-.307.904-1.59 1.872-3.441 1.915-2.162.064-3.042-.032-2.413-.557Zm27.289-8.438a4.1 4.1 0 0 1 .418-1.269s.647-2.344-1.119-5.661l1.294-2.162a.431.431 0 0 1 .297-.21.432.432 0 0 1 .353.085c.154.122.322.268.465.357.294.257.571.533.829.826.843.872 2.68 2.895 2.68 2.895l-.2.204a20.604 20.604 0 0 0-1.862-1.644c-.664-.465-.393.604.025 1.465.418.861.2 2.448-1.072 3.788-1.494 1.594-2.18 2.148-2.108 1.326Z"
        fill="#3B0764"
      />
      <path
        d="m110.138 54.739-37.682-3.613a3.53 3.53 0 0 0-3.835 3.166l-5.4 56.398a3.52 3.52 0 0 0 3.163 3.835l37.679 3.613a3.528 3.528 0 0 0 3.834-3.166l5.404-56.38a3.54 3.54 0 0 0-.783-2.582 3.52 3.52 0 0 0-2.38-1.271Zm-8.066 21.593a12.952 12.952 0 0 1-9.928 11.356 12.948 12.948 0 1 1 1.583-24.73c1.013.38 1.974.885 2.86 1.505a12.93 12.93 0 0 1 5.489 11.869h-.004Z"
        fill="#fff"
        opacity={0.95}
      />
      <path
        d="m91.093 40.933 4.082.783a2.083 2.083 0 0 1 1.644 2.237l-.79 7.19c-.01.095-.028.188-.054.28a1.72 1.72 0 0 1-2.005 1.257l-4.081-.768a2.09 2.09 0 0 1-1.655-1.976 1.551 1.551 0 0 1 0-.286l.79-7.19a1.727 1.727 0 0 1 2.07-1.527Zm1.705 3.431a1.372 1.372 0 0 0-1.637 1.222 1.65 1.65 0 0 0 1.308 1.787 1.37 1.37 0 0 0 1.637-1.222 1.654 1.654 0 0 0-1.308-1.787Z"
        fill="#3B0764"
      />
      <path
        d="M103.669 56.165a.438.438 0 0 1-.396-.25l-1.576-3.256a1.44 1.44 0 0 0-1.151-.804L82.42 50.118a1.43 1.43 0 0 0-1.283.568l-2.166 2.902a.443.443 0 1 1-.715-.525l2.166-2.902a2.327 2.327 0 0 1 2.073-.919l18.122 1.737a2.333 2.333 0 0 1 1.862 1.297l1.573 3.256a.433.433 0 0 1-.022.425.437.437 0 0 1-.371.208h.01ZM66.566 66.21l-.29-.028.201-2.098.293.029-.204 2.098Zm.358-4.06-.29-.028.454-4.753.293.029-.457 4.753Z"
        fill="#7E22CE"
      />
      <path
        d="M104.402 118.281a3.038 3.038 0 0 1-.357-.018l-37.679-3.609a3.67 3.67 0 0 1-3.295-3.996l5.4-56.38a3.67 3.67 0 0 1 3.996-3.295l37.7 3.599a3.67 3.67 0 0 1 3.298 3.995l-5.421 56.402a3.674 3.674 0 0 1-3.642 3.313v-.011ZM72.12 51.258a3.378 3.378 0 0 0-3.352 3.048L63.35 110.69a3.389 3.389 0 0 0 3.034 3.678l37.707 3.606a3.382 3.382 0 0 0 3.674-3.035l5.404-56.38a3.386 3.386 0 0 0-3.031-3.677l-37.696-3.61a3.236 3.236 0 0 0-.322-.014Zm17.075 36.946a13.105 13.105 0 1 1 4.575-25.381c1.026.381 1.999.893 2.895 1.522a13.086 13.086 0 0 1 5.553 12.001 13.102 13.102 0 0 1-13.023 11.858Zm-.032-25.92a12.812 12.812 0 1 0 11.638 7.433 12.794 12.794 0 0 0-4.304-5.129 12.385 12.385 0 0 0-2.83-1.486 12.627 12.627 0 0 0-3.27-.755 11.97 11.97 0 0 0-1.234-.064Z"
        fill="#7E22CE"
      />
      <path
        d="M93.727 62.959a12.962 12.962 0 0 0-16.39 17.393l-12.15 10.035 3.46-36.095a3.53 3.53 0 0 1 3.834-3.166l12.487 1.197 3.995 4.846 4.764 5.79Z"
        fill="#7E22CE"
      />
      <path
        d="m113.301 58.573-2.419 25.192-8.935-10.825a12.993 12.993 0 0 0-5.36-8.477l11.964-9.881 1.587.153a3.523 3.523 0 0 1 3.163 3.838Z"
        fill="#7E22CE"
        opacity={0.8}
      />
      <path
        d="m108.551 54.581-11.965 9.882a12.811 12.811 0 0 0-2.859-1.504l-4.778-5.79-4.006-4.846 23.608 2.258Z"
        fill="#7E22CE"
      />
      <path
        d="m98.697 93.526-22.363-2.142a.683.683 0 0 0-.744.615l-.112 1.167a.683.683 0 0 0 .614.744l22.363 2.142a.682.682 0 0 0 .744-.615l.112-1.167a.683.683 0 0 0-.614-.744Zm-2.185 4.377L77.65 96.096a.683.683 0 0 0-.745.615l-.112 1.167a.682.682 0 0 0 .615.744l18.862 1.806a.682.682 0 0 0 .744-.614l.112-1.167a.683.683 0 0 0-.614-.745Zm-21.91 9.541-5.607-.537-.088.918 5.607.537.088-.918Zm5.784.556-4.522-.433-.088.917 4.522.433.088-.917Zm1.407 2.218-12.995-1.245-.088.918 12.995 1.245.088-.918Zm2.6-3.135-15.314-1.532-.092.922 15.314 1.532.092-.922Z"
        fill="#7E22CE"
        opacity={0.5}
      />
      <path
        d="m94.8 41.548-4.146-.754a1.909 1.909 0 0 0-2.212 1.547l-1.294 7.201c-.019.095-.027.19-.025.286a1.916 1.916 0 0 0 1.562 1.944l4.134.755a1.905 1.905 0 0 0 2.145-1.27c.034-.09.059-.183.075-.278l1.29-7.201a1.922 1.922 0 0 0-1.53-2.23Zm-2.627 2.67a1.525 1.525 0 1 1-.515 3.007 1.525 1.525 0 0 1 .515-3.008Z"
        fill="#3B0764"
      />
      <path
        d="m94.8 41.548-4.146-.754a1.909 1.909 0 0 0-2.212 1.547l-1.294 7.201c-.019.095-.027.19-.025.286a1.916 1.916 0 0 0 1.562 1.944l4.134.755a1.905 1.905 0 0 0 2.145-1.27c.034-.09.059-.183.075-.278l1.29-7.201a1.922 1.922 0 0 0-1.53-2.23Zm-2.627 2.67a1.525 1.525 0 1 1-.515 3.007 1.525 1.525 0 0 1 .515-3.008Z"
        fill="#fff"
        opacity={0.2}
      />
      <path
        d="M102.508 112.38a2.535 2.535 0 1 0-3.228-3.91 2.535 2.535 0 0 0 3.228 3.91Z"
        fill="#7E22CE"
        opacity={0.2}
      />
      <path
        d="M95.8 111.736a2.534 2.534 0 1 0-3.227-3.909 2.534 2.534 0 0 0 3.226 3.909Z"
        fill="#7E22CE"
        opacity={0.8}
      />
    </svg>
  );
}
